import { API_CONFIG, apiUtils } from '../config.js';

// Academic Year API
export const academicYearApi = {
  // Get current academic year
  getCurrent: async () => {
    const url = `${API_CONFIG.BASE_URL}/academic-year/current`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // Get list of academic years
  getList: async () => {
    const url = `${API_CONFIG.BASE_URL}/academic-year/list`;
    return apiUtils.makeAuthenticatedRequest(url);
  },

  // Create academic year
  create: async (data) => {
    const url = `${API_CONFIG.BASE_URL}/academic-year`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  // Set as current academic year
  setCurrent: async (id) => {
    const url = `${API_CONFIG.BASE_URL}/academic-year/${id}/set-current`;
    return apiUtils.makeAuthenticatedRequest(url, {
      method: 'POST',
      body: JSON.stringify({})
    });
  },
};

export default academicYearApi;
